import { default as chatp4KDB1OUpIMeta } from "/app/pages/archive/[slide]/[number]/chat.vue?macro=true";
import { default as fileOxnZxDHl0BMeta } from "/app/pages/archive/[slide]/[number]/file.vue?macro=true";
import { default as indexIKRQbkTP6yMeta } from "/app/pages/archive/[slide]/[number]/index.vue?macro=true";
import { default as mapPVIxsYRaHbMeta } from "/app/pages/archive/[slide]/[number]/map.vue?macro=true";
import { default as indexGJEikJNFljMeta } from "/app/pages/archive/index.vue?macro=true";
import { default as indexN6pT4Un8hYMeta } from "/app/pages/index.vue?macro=true";
import { default as callv8RWFP8PmTMeta } from "/app/pages/login/call.vue?macro=true";
import { default as codeuegJusolFcMeta } from "/app/pages/login/code.vue?macro=true";
import { default as indexgK5VicK7y2Meta } from "/app/pages/login/index.vue?macro=true";
import { default as _91id_93FIXkK569FdMeta } from "/app/pages/news/[id].vue?macro=true";
import { default as indexoxV4GRc61hMeta } from "/app/pages/news/index.vue?macro=true";
import { default as chatTR9uWPyMKnMeta } from "/app/pages/order/[number]/chat.vue?macro=true";
import { default as filenPtOTzJfa2Meta } from "/app/pages/order/[number]/file.vue?macro=true";
import { default as indexTbtxchbxDPMeta } from "/app/pages/order/[number]/index.vue?macro=true";
import { default as mapHTN55LuPz2Meta } from "/app/pages/order/[number]/map.vue?macro=true";
import { default as indexCICQ7TchH0Meta } from "/app/pages/order/index.vue?macro=true";
import { default as chato8ehPrZsR6Meta } from "/app/pages/service/[number]/chat.vue?macro=true";
import { default as indexp45BNqt7XEMeta } from "/app/pages/service/[number]/index.vue?macro=true";
import { default as addu5KR5sGVngMeta } from "/app/pages/service/add.vue?macro=true";
import { default as index85ktHLQIVfMeta } from "/app/pages/service/index.vue?macro=true";
import { default as settingsLwEYOlkQxrMeta } from "/app/pages/settings.vue?macro=true";
export default [
  {
    name: "archive-slide-number-chat",
    path: "/archive/:slide()/:number()/chat",
    component: () => import("/app/pages/archive/[slide]/[number]/chat.vue").then(m => m.default || m)
  },
  {
    name: "archive-slide-number-file",
    path: "/archive/:slide()/:number()/file",
    component: () => import("/app/pages/archive/[slide]/[number]/file.vue").then(m => m.default || m)
  },
  {
    name: "archive-slide-number",
    path: "/archive/:slide()/:number()",
    component: () => import("/app/pages/archive/[slide]/[number]/index.vue").then(m => m.default || m)
  },
  {
    name: "archive-slide-number-map",
    path: "/archive/:slide()/:number()/map",
    component: () => import("/app/pages/archive/[slide]/[number]/map.vue").then(m => m.default || m)
  },
  {
    name: "archive",
    path: "/archive",
    component: () => import("/app/pages/archive/index.vue").then(m => m.default || m)
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue").then(m => m.default || m)
  },
  {
    name: "login-call",
    path: "/login/call",
    meta: callv8RWFP8PmTMeta || {},
    component: () => import("/app/pages/login/call.vue").then(m => m.default || m)
  },
  {
    name: "login-code",
    path: "/login/code",
    meta: codeuegJusolFcMeta || {},
    component: () => import("/app/pages/login/code.vue").then(m => m.default || m)
  },
  {
    name: "login",
    path: "/login",
    meta: indexgK5VicK7y2Meta || {},
    component: () => import("/app/pages/login/index.vue").then(m => m.default || m)
  },
  {
    name: "news-id",
    path: "/news/:id()",
    component: () => import("/app/pages/news/[id].vue").then(m => m.default || m)
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/pages/news/index.vue").then(m => m.default || m)
  },
  {
    name: "order-number-chat",
    path: "/order/:number()/chat",
    component: () => import("/app/pages/order/[number]/chat.vue").then(m => m.default || m)
  },
  {
    name: "order-number-file",
    path: "/order/:number()/file",
    component: () => import("/app/pages/order/[number]/file.vue").then(m => m.default || m)
  },
  {
    name: "order-number",
    path: "/order/:number()",
    component: () => import("/app/pages/order/[number]/index.vue").then(m => m.default || m)
  },
  {
    name: "order-number-map",
    path: "/order/:number()/map",
    component: () => import("/app/pages/order/[number]/map.vue").then(m => m.default || m)
  },
  {
    name: "order",
    path: "/order",
    component: () => import("/app/pages/order/index.vue").then(m => m.default || m)
  },
  {
    name: "service-number-chat",
    path: "/service/:number()/chat",
    component: () => import("/app/pages/service/[number]/chat.vue").then(m => m.default || m)
  },
  {
    name: "service-number",
    path: "/service/:number()",
    component: () => import("/app/pages/service/[number]/index.vue").then(m => m.default || m)
  },
  {
    name: "service-add",
    path: "/service/add",
    component: () => import("/app/pages/service/add.vue").then(m => m.default || m)
  },
  {
    name: "service",
    path: "/service",
    component: () => import("/app/pages/service/index.vue").then(m => m.default || m)
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/app/pages/settings.vue").then(m => m.default || m)
  }
]